var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notifications-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11515",
    "data-name": "Path 11515",
    d: "M0,0H14V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11516",
    "data-name": "Path 11516",
    d: "M10.222,16a1.482,1.482,0,0,0,1.556-1.385H8.667A1.477,1.477,0,0,0,10.222,16Zm4.667-7.615a4.3,4.3,0,0,0-3.5-4.375V3.538A1.107,1.107,0,0,0,10.222,2.5,1.107,1.107,0,0,0,9.056,3.538v.471c-.187.042-.366.1-.537.159l6.37,5.67ZM5.1,3.088,4,4.065,6.186,6.01a4.664,4.664,0,0,0-.63,2.375v3.462l-1,.893A.686.686,0,0,0,5.1,13.923h9.979l1.353,1.2,1.1-.976Z",
    transform: "translate(-4)",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsOff);
export default __webpack_public_path__ + "static/media/notifications-off.facaacb8eb8d169075427e716f74f46b.svg";
export { ForwardRef as ReactComponent };